import { computed, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { currentChat } from '@/interfaces/composables/useChatManager';
import { authState } from '@/interfaces/composables/auth/authState';

export function useSharedChatDetection() {
  const route = useRoute();

  const isShared = computed(() => {
    return (
      !!route.query.sharedId ||
      route.path.includes('/chat/shared-') ||
      currentChat.value?.id?.startsWith('shared-') === true
    );
  });

  watchEffect(() => {
    authState.isSharedChatView.value = isShared.value;
  });

  return { isShared };
}
